/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { ReactElement } from "react";

import { isEmpty, sortBy } from "lodash";

import { Spinner, SpinnerSize, Stack, StackItem, Text } from "@fluentui/react";

import CommentDetail from "Components/CommentDetail/CommentDetail";
import {
  bodyContainerStackStyles,
  headerStackStyles,
  headerTextStyles,
  ContainerWrapper,
} from "Components/Common/SharedTableStyles.styles";

import { messageStackStyles } from "./CommentsHistory.styles";
import { ICommentsHistoryProps } from "./ICommentsHistoryProps";

export const CommentsHistory = (props: ICommentsHistoryProps): ReactElement => {
  const { userProfileComments, errorMessage, isLoading } = props;

  return (
    <ContainerWrapper>
      <Stack styles={headerStackStyles}>
        <Text styles={headerTextStyles}>History</Text>
      </Stack>
      <Stack styles={bodyContainerStackStyles}>
        {!isEmpty(userProfileComments) ? (
          sortBy(userProfileComments, (comment) => {
            return new Date(comment.dateCreated);
          })
            .reverse()
            .map((userProfileComment, index) => (
              <StackItem key={index}>
                <CommentDetail userProfileComment={userProfileComment} />
              </StackItem>
            ))
        ) : !!errorMessage ? (
          <StackItem styles={messageStackStyles}>{errorMessage}</StackItem>
        ) : isLoading ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <StackItem styles={messageStackStyles}>No comments to display.</StackItem>
        )}
      </Stack>
    </ContainerWrapper>
  );
};
